const STORAGE_KEY = 'sp_role_frequency';
const MAX_PILLS = 8;

function readFrequencies() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
  } catch {
    return {};
  }
}

/**
 * Drop a role from the frequency store so it stops showing up as a shortcut.
 * It can come back if the role gets picked again later.
 */
export function forgetRole(roleId) {
  if (!roleId) return;
  const freq = readFrequencies();
  if (!(roleId in freq)) return;
  delete freq[roleId];
  localStorage.setItem(STORAGE_KEY, JSON.stringify(freq));
}

export function recordRoleSelections(roleIds) {
  if (!roleIds?.length) return;
  const freq = readFrequencies();
  roleIds.forEach((id) => { freq[id] = (freq[id] || 0) + 1; });
  localStorage.setItem(STORAGE_KEY, JSON.stringify(freq));
}

/**
 * Returns up to MAX_PILLS roles that have been selected before,
 * filtered from `allRoles`, sorted alphabetically for display.
 * Internally ranked by frequency to pick the top candidates.
 */
export function getFrequentRoles(allRoles) {
  const freq = readFrequencies();
  return allRoles
    .filter((r) => (freq[r.id] || 0) > 0)
    .sort((a, b) => (freq[b.id] || 0) - (freq[a.id] || 0))
    .slice(0, MAX_PILLS)
    .sort((a, b) => a.name.localeCompare(b.name));
}
